import React from "react";
import { BaseLandingCard } from "../BaseLandingCard";

export const RemediationConfirmationScreen = ({
  investingAccount,
  skipClickHandler,
  continueClickHandler,
  submittingResponse,
}: {
  investingAccount: string;
  skipClickHandler: () => void;
  continueClickHandler: () => void;
  submittingResponse: boolean;
}) => {
  const description = `Due to regulatory requirements, you must provide additional information about ${investingAccount ?? "the investing account"}.`;

  return (
    <BaseLandingCard
      illustrationName="account_overview"
      title="Investing account information"
      description={description}
      onContinue={continueClickHandler}
      onSkip={skipClickHandler}
      isLoading={submittingResponse}
    />
  );
};
